const faEllipsisVertical = {
  prefix: 'fal',
  iconName: 'ellipsis-vertical',
  icon: [
    64,
    512,
    ['ellipsis-v'],
    'f142',
    'M32 416c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm0-192c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM0 64A32 32 0 1 1 64 64 32 32 0 1 1 0 64z',
  ],
};
export default faEllipsisVertical;
